import { render, staticRenderFns } from "./IndexAlt.vue?vue&type=template&id=5abb01f2&scoped=true&"
import script from "./IndexAlt.vue?vue&type=script&lang=js&"
export * from "./IndexAlt.vue?vue&type=script&lang=js&"
import style0 from "./IndexAlt.vue?vue&type=style&index=0&id=5abb01f2&scoped=true&lang=css&"
import style1 from "./IndexAlt.vue?vue&type=style&index=1&id=5abb01f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb01f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VApp,VBottomSheet,VBtn,VCardTitle,VCarousel,VCarouselItem,VContainer,VContent,VDivider,VIcon,VSheet,VTab,VTabItem,VTabs,VTabsSlider})
